import type { ApplicationApi } from "./applicationApi";

export const journalPurposes = [
  ["primaryJournal", "Journal"],
] as const;

export const accountPurposes = [
  ["principal_liability", "Principal liability"],
  ["current_portion_debt", "Current portion of debt"],
  ["long_term_portion_debt", "Long-term portion of debt"],
  ["interest_expense", "Interest expense"],
  ["accrued_interest_payable", "Accrued interest payable"],
  ["loan_clearing", "Loan clearing"],
  ["bank_account", "Bank account"],
  ["deferred_financing_costs", "Deferred financing costs"],
  ["financing_fee_expense", "Financing fee expense"],
  ["late_fee_expense", "Late fee expense"],
  ["capitalized_interest", "Capitalized interest"],
  ["gain_loss_extinguishment", "Gain/loss on extinguishment"],
] as const;

type JournalPurpose = typeof journalPurposes[number][0];
type AccountPurpose = typeof accountPurposes[number][0];
export type DimensionType = "entity" | "location" | "department" | "class" | "project" |
  "vendor" | "customer" | "employee" | "item" | "user_defined";

export interface AccountingSettingsDocument {
  accounts: Record<AccountPurpose, string | null>;
  dimensions: Array<{
    dimensionKey: string;
    dimensionType: DimensionType;
    displayName: string;
    masterRecordId: string | null;
  }>;
  journals: Record<JournalPurpose, string | null>;
  postingRules: {
    attachPostingSupport: boolean;
    batchGroupingMode: "per_loan" | "per_entity_date" | "consolidated";
    closedPeriodBehavior: "block" | "next_open_period";
    directPostingEnabled: boolean;
    draftEntryByDefault: boolean;
    postingDescriptionTemplate: string;
  };
  version: number;
}

export interface AccountingSettingsResponse {
  options: Array<{
    dimensionKey: string | null;
    displayName: string;
    id: string;
    recordId: string | null;
    recordNo: string;
    recordType: string;
    status: "active" | "inactive";
  }>;
  settings: AccountingSettingsDocument;
}

export function getAccountingSettings(api: ApplicationApi): Promise<AccountingSettingsResponse> {
  return api.get<AccountingSettingsResponse>("accounting-settings");
}

export function saveAccountingSettings(
  api: ApplicationApi,
  settings: AccountingSettingsDocument,
): Promise<AccountingSettingsResponse> {
  return api.put<AccountingSettingsResponse, AccountingSettingsDocument>("accounting-settings", settings);
}
